import React from 'react'

export { default as SchedulePageNavigationItem } from './components/SchedulePageNavigationItem'

export const LazySchedulePage = React.lazy(() => import('./SchedulePage'))
